"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Mirage_OnAttackedEventHandlerScript = void 0;
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Effect_Mirage_OnAttackedEventHandlerScript = class Effect_Mirage_OnAttackedEventHandlerScript {
    run(sequence, container, handler, event) {
        if ((0, Random_1.randomPercent)() >= 20) {
            return;
        }
        const invoker = container.getActor(event.subject);
        const mirageArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.MagicianMirage, invoker.level, Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
            let multiplier = .5;
            pet[key] = Math.round(value * multiplier);
            return pet;
        }, {}), {
            [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("Jolt").mk(),
        })
            .withAi("NoOp", {});
        container.summonCompanion(sequence, event.subject, mirageArgs);
    }
};
Effect_Mirage_OnAttackedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Mirage_OnAttacked")
], Effect_Mirage_OnAttackedEventHandlerScript);
exports.Effect_Mirage_OnAttackedEventHandlerScript = Effect_Mirage_OnAttackedEventHandlerScript;
